import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from 'react-visibility-sensor';

import swiperImg1 from "../../../assets/img/landingPageOne/sectionOne/sectionOne-img.webp";

function SectionOne(){

    const [isVisible, setIsVisible] = useState(false);
    const { t } = useTranslation();

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <section>
            <VisibilitySensor onChange={onChange} partialVisibility minTopValue={200}>
                <div className="sectionOneBg">
                    <div className="sectionOne">
                        <div className="heroContent">
                            <h1 className={`${isVisible ? 'visible' : ''}`}>
                                {t("lp1_hero1")} <span>{t("lp1_hero1_span")}</span>
                            </h1>
                            <p className={`heroSub ${isVisible ? 'visible' : ''}`}>
                                {t("lp1_hero_sub")}
                            </p>
                            <p className={`heroSupport ${isVisible ? 'visible' : ''}`}>
                                {t("lp1_hero2")} {t("lp1_hero2_span")}
                            </p>
                            <p className={`atention`} dangerouslySetInnerHTML={{ __html: t("lp1_hero_atention") }}/>
                            <div className={`heroCtas ${isVisible ? 'visible' : ''}`}>
                                <a href="#contact"><button>{t("lp1_hero_cta1")}</button></a>
                                {/* <a href="#contact"><button className="btnOutline">{t("lp1_hero_cta2")}</button></a> */}
                            </div>
                        </div>
                        <img className={`img ${isVisible ? 'visible' : ''}`} src={swiperImg1} alt="" width={'550px'} height={'500px'} />
                    </div>
                </div>
            </VisibilitySensor>
        </section>
    )
}

export default SectionOne;
